<mat-card class="file-panel source-panel">
  <mat-card-header>
    <mat-card-title>
      {{label}}
    </mat-card-title>
  </mat-card-header>
  <div class="search-container"
       [ngClass]="{'active': showSearchInput}">
    <div class="search-input-wrapper">
      <mat-icon>
        search
      </mat-icon>
      <input #searchInput
             placeholder="Search files and folders..."
             type="text"
             (keydown.enter)="onSearchClioFiles(searchInput.value)">
      <!-- Search button added -->
      <button class="nuage-button search-button"
              [disabled]="!searchInput.value || searchInput.value.trim() === ''"
              (click)="onSearchClioFiles(searchInput.value)">
        Search
      </button>
      <button *ngIf="searchInput.value"
              class="clear-search-button"
              (click)="onClearSearch()">
        <mat-icon>
          close
        </mat-icon>
      </button>
    </div>
  </div>
  <mat-card-content>
    <!-- Breadcrumb navigation -->
    <!-- <div class="breadcrumb-container">
      <div class="breadcrumbs">
        <ng-container *ngFor="let breadcrumb of breadcrumbs; let i = index; let last = last">
          <span class="breadcrumb-item"
                [ngClass]="{'active': last}"
                (click)="navigateToBreadcrumb(i)">
            <mat-icon class="breadcrumb-icon">
              {{ i === 0 ? 'home' : 'folder' }}
            </mat-icon>
            {{breadcrumb.name}}
          </span>
          <span *ngIf="!last"
                class="breadcrumb-separator">
            <mat-icon>
              chevron_right
            </mat-icon>
          </span>
        </ng-container>
      </div>
    </div> -->

    <!-- Current folder contents display - replaced with tree view -->
    <div class="file-tree-container">
      <!-- No results message when search has no matches -->
      <div *ngIf="filteredFolderContents.length === 0 && searchQuery"
           class="no-search-results">
        <p>
          No files matching "{{searchQuery}}"
        </p>
      </div>

      <!-- Tree View - Recursive Component -->
      <div class="tree-view">
        <!-- Column Headers -->
        <div class="file-list-header">
          <div class="header-column header-name">
            Name
          </div>
          <div class="header-column header-size">
            Size
          </div>
          <div class="header-column header-date">
            Last edit at
          </div>
        </div>

        <!-- Show all items from the filtered contents -->
        <ng-container *ngFor="let item of getDisplayedItems()">
          <div class="tree-node"
               [attr.aria-label]="item.accessibilityLabel ? item.name + ' - ' + item.accessibilityLabel : ''"
               [attr.title]="item.alreadyTransferred ? 'Already shared to NuageDx' : ''"
               [ngClass]="{
                 'selected': item.selected,
                 'already-transferred': item.alreadyTransferred,
                 'expanded-folder': item.type === 'folder' && item.expanded,
                 'depth-0': getItemDepth(item) === 0,
                 'depth-1': getItemDepth(item) === 1,
                 'depth-2': getItemDepth(item) === 2,
                 'depth-3': getItemDepth(item) === 3,
                 'depth-4': getItemDepth(item) === 4,
                 'depth-5': getItemDepth(item) === 5,
                 'depth-6': getItemDepth(item) === 6,
                 'with-depth': getItemDepth(item) > 0
               }"
               [style.--depth]="getItemDepth(item)">
            <!-- Folder expand/collapse icon -->
            <span *ngIf="item.type === 'folder' && !(item.depth === 0 && item.name === sourceObjectName)"
                  class="tree-toggle show-toggle-icon"
                  role="button"

                  [attr.aria-expanded]="item.expanded"
                  [attr.aria-label]="item.expanded ? 'Collapse folder' : 'Expand folder'"
                  (click)="onToggleFolder(item)">
              <mat-icon>
                {{item.expanded ? 'remove' : 'add'}}
              </mat-icon>
            </span>
            <!-- Empty spacer for root folder that doesn't have expand/collapse control -->
            <span *ngIf="item.type === 'folder' && (item.depth === 0 && item.name === sourceObjectName)"
                  class="tree-toggle-spacer"></span>
            <span *ngIf="item.type !== 'folder'"
                  class="tree-toggle-spacer"></span>

            <!-- Checkbox for files - show disabled if already transferred -->
            <mat-checkbox *ngIf="item.type === 'file' || item.type === 'image'"
                          [attr.aria-label]="item.alreadyTransferred ? item.name + ' - Already shared to NuageDx, not available for selection' : 'Select ' + item.name"
                          [checked]="item.selected"
                          [disabled]="isFileAlreadyTransferred(item) || !fileCheckingComplete"
                          (change)="onToggleFileSelection(item, $event.checked)">
            </mat-checkbox>

            <!-- Checkbox for folders - show disabled if already transferred -->
            <mat-checkbox *ngIf="item.type === 'folder' && ((item.name === sourceObjectName && hasFolderNonTransferredChildren(item)) || item.name !== sourceObjectName)"
                          [attr.aria-label]="item.alreadyTransferred ? 'Folder ' + item.name + ' - Already shared to NuageDx, not available for selection' : 'Select folder ' + item.name"
                          [checked]="isFolderSelected(item)"
                          [disabled]="isFileAlreadyTransferred(item) || !fileCheckingComplete"
                          [indeterminate]="areSomeFolderFilesSelected(item)"
                          (change)="onToggleFolderSelection(item, $event.checked)">
            </mat-checkbox>

            <!-- Empty spacer for root folders with no non-transferred children -->
            <span *ngIf="item.type === 'folder' && item.name === sourceObjectName && !hasFolderNonTransferredChildren(item)"
                  class="tree-toggle-spacer"></span>

            <!-- File icon for files -->
            <mat-icon *ngIf="item.type === 'file'"
                      class="file-icon"
                      aria-hidden="true"
                      [ngClass]="{'transferred-icon': item.alreadyTransferred}">
              description
            </mat-icon>

            <!-- Image icon for images -->
            <mat-icon *ngIf="item.type === 'image'"
                      class="file-icon"
                      aria-hidden="true"
                      [ngClass]="{'transferred-icon': item.alreadyTransferred}">
              image
            </mat-icon>

            <!-- Folder icon for folders -->
            <mat-icon *ngIf="item.type === 'folder'"
                      class="folder-icon"
                      aria-hidden="true"
                      [ngClass]="{'transferred-icon': item.alreadyTransferred}">
              {{item.expanded ? 'folder_open' : 'folder'}}
            </mat-icon>

            <!-- Folder name (clickable for navigation) -->
            <span *ngIf="item.type === 'folder'"
                  class="folder-name"
                  [ngClass]="{'transferred-text': item.alreadyTransferred}">
              {{item.name}}
              <!-- For folders - remove "Already in NuageDx" text -->
              <ng-container *ngIf="item.alreadyTransferred">
                <span class="transferred-indicator"
                      aria-hidden="false">
                  <mat-icon class="transferred-check"
                            aria-hidden="false">
                    check_circle
                  </mat-icon>
                  <!-- Removed "Already in NuageDx" text -->
                </span>
                <!-- Updated screen reader text -->
                <span class="sr-only">
                  This folder has already been transferred
                </span>
              </ng-container>
            </span>

            <!-- File name (now clickable for preview) -->
            <span *ngIf="item.type !== 'folder'"
                  class="clickable file-name"
                  [ngClass]="{'transferred-text': item.alreadyTransferred}"
                  (click)="onOpenClioFilePreview(item)">
              {{item.name}}
              <!-- For files - remove "Already in NuageDx" text -->
              <ng-container *ngIf="item.alreadyTransferred">
                <span class="transferred-indicator"
                      aria-hidden="false">
                  <mat-icon class="transferred-check"
                            aria-hidden="false">
                    check_circle
                  </mat-icon>
                  <!-- Removed "Already in NuageDx" text -->
                </span>
                <!-- Updated screen reader text -->
                <span class="sr-only">
                  already shared
                </span>
              </ng-container>
            </span>

            <!-- Size column for files -->
            <span *ngIf="item.type === 'file'"
                  class="file-size">
              {{item.size || 'N/A'}}
            </span>

            <!-- Last Modified column for files -->
            <span *ngIf="item.type === 'file'"
                  class="file-date">
              {{item.date || 'N/A'}}
            </span>

            <!-- Placeholder for folders -->
            <span *ngIf="item.type === 'folder'"
                  class="folder-size">
            </span>

            <span *ngIf="item.type === 'folder'"
                  class="folder-date">
            </span>
          </div>
        </ng-container>
      </div>

      <!-- Empty folder message -->
      <div *ngIf="currentFolderContents.length === 0 && !searchQuery"
           class="empty-folder-message">
        <mat-icon>
          info
        </mat-icon>
        <p>
          This folder is empty.
        </p>
      </div>
    </div>
    <!-- end file-tree-container -->
    <!-- Instructions label -->
    <div class="instructions">
      Select the files to be shared
    </div>
  </mat-card-content>

</mat-card>
